import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyDBkx4KX5G6mnRnYBKN_k0FGtkPRiGzZuU',
  authDomain: 'sjs-technology.firebaseapp.com',
  projectId: 'sjs-technology',
  storageBucket: 'sjs-technology.firebasestorage.app',
  messagingSenderId: '30732567404',
  appId: '1:30732567404:web:dc30ebe332593766226949',
  measurementId: 'G-JF3QWQFS32',
}

const app = initializeApp(firebaseConfig)

export const db = getFirestore(app)
export const auth = getAuth(app)

export default app
